export default "/assets/images/twilight-blue.8127692e4acbddde.webp";